import { procurementAPI } from "../../axios";

export const actions = {
    GetBacSetting(context, data){
        return procurementAPI.get(`BacSetting/Campus/${data}`);
    },
    GetSingleBacSetting(context, data){
        return procurementAPI.get(`BacSetting/${data}`);
    },
    UpdateBacSetting(context, data){
        return procurementAPI.put(`BacSetting/Update/${data.id}`, data);
    },
    DeleteBacSetting(context, data){
        return procurementAPI.delete(`BacSetting/Remove/${data}`);
    },
    CreateBacSetting(context, data){
        return procurementAPI.post(`BacSetting/Create/${data.campusId}`, data);
    },

    // Bac Member
    GetBacMemberAll(context, data){
        return procurementAPI.get(`BacSetting/BacMembers/All/${data}`);
    },
    GetBacMemberActive(context, data){
        return procurementAPI.get(`BacSetting/BacMembers/Active/${data}`);
    },
    GetSingleBacMember(context, data){
        return procurementAPI.get(`BacSetting/${data}`);
    },
    UpdateBacMember(context, data){
        return procurementAPI.put(`BacSetting/BacMember/Update/${data.id}`, data);
    },
    DeleteBacMember(context, data){
        return procurementAPI.delete(`BacSetting/BacMember/Remove/${data}`);
    },
    CreateBacMember(context, data){
        return procurementAPI.post(`BacSetting/BacMember`, data);
    },
}